export default {
  DOTA: 'dota2',
  FIFA: 'fifa',
  CHESS: 'chess',
  FUTSAL: 'futsal',
  CARROM_BOARD: 'carrom-board',
  TABLE_TENNIS: 'table-tennis',
  COUNTER_STRIKE: 'counter-strike'
};
